export default class RemovalShipmentDetailsInfo {
    constructor(shipmentId, state, cancellationReason, lastUpdatedDate, stateDescription) {
        this.shipmentId = shipmentId;
        this.state = state;
        this.cancellationReason = cancellationReason;
        this.lastUpdatedDate = lastUpdatedDate;
        this.stateDescription = stateDescription;
    }
}